import { Box, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import WTypography from '../../../../../Components/whiteTypography'
import DonutChart1 from '../../../Component/Charts/IncomeDonut'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function DonutChart({ data, setData, slug }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const getAppStore = useSelector((store) => store.appStore).appStore
  const siteDevise = useSelector((store) => store.devise)
  const user = useSelector((store) => store.user?.user)

  const [headerValue, setHeaderValue] = useState(0)

  // LAP-733 (GE022) — derive labels via i18next
  const getGroupingText = () => {
    const viewType = getAppStore?.viewType || 'Global'
    const operation = slug === 'R' ? t('dashboardDetail.incomeLower') : t('dashboardDetail.expensesLower')
    let grouping = t('dashboardDetail.category')
    if (viewType === 'Category') grouping = t('dashboardDetail.subcategory')
    else if (viewType === 'Accounts') grouping = t('dashboardDetail.accounts')
    return t('dashboardDetail.breakdownBy', { operation, grouping: grouping.toLowerCase() })
  }

  useEffect(() => {
    if (data && data.calculation && data.calculation.header_value)
      setHeaderValue(data.calculation.header_value)
    else setHeaderValue(0)
  }, [data])
  
  return (
    <Card className="dashboard_card__root">
      <Box className="dashboard_card__header">
        <WTypography component={'span'} variant="h5">
          {slug === 'R' ? t('dashboardDetail.income') : t('dashboardDetail.expenses')}
        </WTypography>
        <WTypography component={'span'} variant="h5">
          {/* Backend now returns converted values based on currency parameter */}
          {parseFloat(headerValue).toFixed(2)}
        </WTypography>
      </Box>

      <WTypography variant={'body2'}>
        {getGroupingText()}
      </WTypography>
      <Box
        mt={2}
        minWidth={3}
        className={getAppStore.expandChart ? 'height-500' : 'height-500'}
        display={'flex'}
        justifyContent={'center'}
      >
        <DonutChart1 setHeaderValue={setHeaderValue} reports={data} yearData={setData} />
      </Box>
    </Card>
  )
}

export default DonutChart
